import { createElement } from 'react';
import { createSvg } from './createSvg.js';
import '@vebox/etui-system';
import '@vebox/etui-system-elements';

const LocationGlyph = /*#__PURE__*/createElement("g", {
  id: "location"
}, /*#__PURE__*/createElement("path", {
  d: "M42.33,51.34a13.69,13.69,0,1,1,9.69-4A13.66,13.66,0,0,1,42.33,51.34Zm0-24.38a10.69,10.69,0,1,0,7.57,3.13A10.7,10.7,0,0,0,42.33,27Z"
}), /*#__PURE__*/createElement("path", {
  d: "M42,70a1.47,1.47,0,0,1-1.06-.44L28.23,56.81l-.05,0,0-.05c-2.29-2.19-9.75-10-9.75-19.07a23.62,23.62,0,0,1,47.23,0c0,10.08-7.62,17.42-9.86,19.14v0L43.06,69.52A1.47,1.47,0,0,1,42,70ZM30.35,54.69,42,66.34,53.65,54.69a1.33,1.33,0,0,1,.3-.23c.59-.47,8.67-7.17,8.67-16.81a20.62,20.62,0,0,0-41.23,0c0,7.85,6.75,14.92,8.82,16.9l.13.14Z"
}));
const Location = createSvg({
  name: 'location',
  path: LocationGlyph
});

export default Location;
export { LocationGlyph };
